import { render, staticRenderFns } from "./problemStaus.vue?vue&type=template&id=00f762dc&scoped=true&"
import script from "./problemStaus.vue?vue&type=script&lang=js&"
export * from "./problemStaus.vue?vue&type=script&lang=js&"
import style0 from "./problemStaus.vue?vue&type=style&index=0&id=00f762dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f762dc",
  null
  
)

export default component.exports